import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    requests: {
      title: "UR都市機構入居者様専用 お問い合わせフォーム",
      No1: "姓",
      No2: "名",
      No3: "姓（フリガナ）",
      No4: "名（フリガナ）",
      No5: "郵便番号",
      No6: "都道府県",
      No7: "都道府県以下",
      No8: "物件名",
      No9: "部屋番号",
      No10: "電話番号",
      No11: "メールアドレス",
      No12: "お問い合わせ内容",
      No13: "外出登録の設定",
      No14: "電話番号",
      No15: "緊急連絡先氏名",
      No16: "緊急連絡先電話番号",
      No17: "緊急連絡先メールアドレス",
      No18: "緊急連絡先郵便番号",
      No19: "解約理由",
      No20: "解約について",
      No21: "お問い合わせ内容詳細",
      No22: "個人情報保護基本方針について同意",
      
    },
    buttons: {
      addressInput: '住所自動入力',
      submit: '登録',
      confirm: '確認',
      next: '次へ',
      back: '戻る'
    }
  },
  scheduleInput: {
    set: "選択",
    clear: "クリア",
    cancel: "キャンセル"
  },
  'Illegal postal code': '郵便番号は7桁の数字を入力してください。',
  required: '入力してください',
  'too small': '文字数が不足しています',
  'too large': '文字数が超過しています',
  'Expected string, received null': '入力してください',
  'not postalCode': '郵便番号はハイフンを含まない7つの数字で入力してください',
  'length is': '文字入力してください',
  'must kana': '全角カタカナで入力してください',
  'must number': 'ハイフンなしの数字で入力してください',
  'must mobile': '携帯電話番号を入力してください',
  'must email': 'メールアドレスを入力してください',
  'Expected array, received null': '入力してください'
}
